import AppSections from "./utils/AppSections";
import AppSubSections from "./utils/AppSubSections";

export interface IPath {
  section?: AppSections;
  id?: number;
  subsection?: AppSubSections;
  additionalSections?: string[];
}

export const formatDate = (date: { toISOString: () => string }) => {
  return date.toISOString().replace("T", " ").slice(0, 19);
};

export const formatDateZeroTime = (date: { toISOString: () => string }) => {
  return date.toISOString().slice(0, 10) + " 00:00:00";
};

const SETTINGS = {
  // API_ROOT: "https://localhost",
  // API_ROOT: "https://cgisdev.utcluj.ro/cheminovaStagingAPI",
  API_ROOT: process.env.REACT_APP_API_ROOT!,
  history: new Array<IPath>(),
  get_path: function (params: IPath) {
    let path = "/";
    if (params.section !== "/") {
      path += params.section + "/";
    }
    if (params.id) {
      path += params.id?.toString() + "/";
    }
    if (params.additionalSections && params.additionalSections.length > 0) {
      for (let additionalSection of params.additionalSections) {
        path += additionalSection + "/";
      }
    }
    if (params.subsection) {
      path += params.subsection;
    }
    this.history.push(params);
    return path;
  },
  go_back: function (defaultPath: IPath) {
    // remove current url from the history
    let previous = this.history.pop();
    // get previous URL (if exists) and remove it from history
    previous = this.history.pop();
    if (previous) {
      return this.get_path(previous);
    }
    return this.get_path(defaultPath);
  },
};

export default SETTINGS;
